import { Skeleton } from '@linka/ui/skeleton';

export const ListSkeleton = () => {
  return (
    <div className='space-y-mini'>
      <Skeleton className='w-full h-xxxl' />
      <Skeleton className='w-full h-xxxl' />
      <Skeleton className='w-full h-xxxl' />
      <Skeleton className='w-full h-xxxl' />
    </div>
  );
};
